export default __webpack_public_path__ + "static/media/gif6.1ddc98eb.gif";